import { PropsWithChildren } from 'react';

type CellComponentProps = {
  level: number;
};

export const CellComponent = ({
  children,
  level,
}: PropsWithChildren<CellComponentProps>) => {
  return (
    <span
      style={{
        paddingLeft: (level - 1) * 24,
        fontWeight: level === 1 ? 600 : 400,
      }}
    >
      {children}
    </span>
  );
};
